import Reveal from "./Reveal";
import { professional } from "@/config/professional";

const posts = [
  {
    image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/bfa2776594c58e595b7827567f85d82e.png",
    href: "https://www.instagram.com/p/DQaUhSwjTyL/",
    alt: "Prazer, a sua Estomaterapeuta!",
  },
  {
    image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/2fb41c892a39bc19fb3d6f70379b37c0.png",
    href: "https://www.instagram.com/p/DSnGycujTes/?img_index=1",
    alt: "Sinais de amigdalite: O que você precisa saber!",
  },
  {
    image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/01226c83acda828d5d1aea47810ac5e7.png",
    href: "https://www.instagram.com/p/DVi2ysrDeAt/?img_index=1",
    alt: "O que eu descobri sobre ser mulher",
  },
  {
    image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/5c4db8e8fc503816f5b10f9ecaea786f.png",
    href: "https://www.instagram.com/p/DV6Tm6XjRYH/",
    alt: "Laserterapia - Transformando dor em sorriso",
  },
  {
    image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/101bf56e705e27db2381ae5abce44185.png",
    href: "https://www.instagram.com/p/DZGR8RXxRHL/",
    alt: "Tratamento com Laserterapia",
  },
  {
    image: "https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/f4e7f196750baa48df17755f809cc78f.png",
    href: "https://www.instagram.com/p/DXh4osLlFeG/?img_index=1",
    alt: "Mapa da Fibromialgia",
  },
];

export default function InstagramFeed() {
  return (
    <section id="instagram" className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Reveal>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
                Instagram
              </p>
              <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
                Saúde também se constrói com informação.
              </h2>
              <p className="mt-5 text-base leading-relaxed text-foreground-600 md:text-lg">
                Acompanhe conteúdos sobre Estomaterapia, Laserterapia,
                cicatrização, cuidados e qualidade de vida.
              </p>
            </Reveal>
          </div>

          <Reveal delay={80}>
            <a
              href={professional.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-600/30 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-600 hover:text-background-50"
            >
              <i className="ri-instagram-line text-lg" aria-hidden="true"></i>
              Seguir no Instagram
            </a>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-6">
          {posts.map((post, i) => (
            <Reveal key={i} delay={i * 50}>
              <a
                href={post.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Publicação no Instagram: ${post.alt}`}
                className="group relative block aspect-square overflow-hidden rounded-lg"
              >
                <img
                  src={post.image}
                  alt={post.alt}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/0 transition-colors duration-300 group-hover:bg-black/30">
                  <i className="ri-instagram-line text-3xl text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100" aria-hidden="true"></i>
                </div>
              </a>
            </Reveal>
          ))}
          {Array.from({ length: 6 - posts.length }).map((_, i) => (
            <Reveal key={`placeholder-${i}`} delay={(posts.length + i) * 50}>
              <a
                href={professional.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Veja mais publicações no Instagram"
                className="group flex aspect-square items-center justify-center rounded-lg bg-secondary-100 transition-colors duration-300 hover:bg-secondary-200"
              >
                <i
                  className="ri-instagram-line text-3xl text-secondary-500 transition-colors duration-300 group-hover:text-secondary-700"
                  aria-hidden="true"
                ></i>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={100}>
          <p className="mt-6 text-sm text-foreground-500">
            {professional.instagramHandle}
          </p>
        </Reveal>
      </div>
    </section>
  );
}